import React from 'react';
import cd from 'debug';
import cn from 'classnames';
import { API } from '@gin-betting/core';

import { MarketTitle, VS } from 'components';
import { AsyncOddButton } from 'modules/betslip/async';
import { Market } from './TopMarketsContainer';
import globalMessages from 'messages';
import './MarketDefault.scss';

const debug = cd('match-list:components:MarketDefault');

interface OwnProps {
    market?: Market;
    hasMatchHeader?: boolean;
    hasVS?: boolean;
    isDefaultName?: boolean;
}

type Props = OwnProps;

export default class MarketDefault extends React.Component<Props> {
    static defaultProps: Required<Pick<Props, 'market'>> = {
        market: {
            id: '',
            priority: 0,
            status: API.MarketStatus.SUSPENDED,
            odds: ['', ''],
            name: '',
            specifiers: [],
            typeId: -999,
            tags: [],
        },
    };

    renderOdds = () => {
        const { market, hasVS } = this.props;
        const { odds } = market!;

        const oddsComponents = odds.slice(0, 3).map((oddId, idx) => (
            <div
                styleName={cn('button', {
                    'has-three-odds': odds.length > 2,
                })}
                key={oddId || idx}
                className="__app-MarketDefault-button"
            >
                <AsyncOddButton oddId={oddId} showResult={true} />
            </div>
        ));

        if (hasVS && oddsComponents.length === 2) {
            oddsComponents.splice(
                1,
                0,
                <div styleName="vs" key="vs" className="__app-MarketDefault-VS">
                    <VS />
                </div>
            );
        }

        return oddsComponents;
    };

    render() {
        debug('render', this.props);
        const { market, hasMatchHeader, isDefaultName } = this.props;
        const { name } = market!;

        return (
            <div
                styleName="container"
                className="__app-MarketDefault-container "
            >
                {hasMatchHeader && (
                    <MarketTitle
                        name={isDefaultName ? '' : name}
                        defaultMsg={globalMessages.marketWinner}
                    />
                )}
                {this.renderOdds()}
            </div>
        );
    }
}
